import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/academy`;

const authHeader = () => {
  const t = localStorage.getItem('dermascan_token');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const academyApi = {
  async listPostes() {
    const { data } = await axios.get(`${BASE}/postes`, { headers: authHeader() });
    return data;
  },
  async seedDefaultCatalog(force = false) {
    const { data } = await axios.post(
      `${BASE}/admin/seed-default-catalog?force=${force}`,
      {},
      { headers: authHeader() },
    );
    return data;
  },
  async listTrainings(params = {}) {
    const { data } = await axios.get(`${BASE}/trainings`, {
      params,
      headers: authHeader(),
    });
    return data;
  },
  async getTraining(id) {
    const { data } = await axios.get(`${BASE}/trainings/${id}`, { headers: authHeader() });
    return data;
  },
  async createTraining(payload) {
    const { data } = await axios.post(`${BASE}/trainings`, payload, { headers: authHeader() });
    return data;
  },
  async updateTraining(id, payload) {
    const { data } = await axios.put(`${BASE}/trainings/${id}`, payload, { headers: authHeader() });
    return data;
  },
  async deleteTraining(id) {
    const { data } = await axios.delete(`${BASE}/trainings/${id}`, { headers: authHeader() });
    return data;
  },
  async startEnrollment(trainingId) {
    const { data } = await axios.post(
      `${BASE}/enrollments/start/${trainingId}`,
      {},
      { headers: authHeader() },
    );
    return data;
  },
  async uploadCertificate(enrollmentId, file, certificateNumber) {
    const form = new FormData();
    form.append('file', file);
    if (certificateNumber) form.append('certificate_number', certificateNumber);
    const { data } = await axios.post(
      `${BASE}/enrollments/${enrollmentId}/certificate`,
      form,
      { headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' } },
    );
    return data;
  },
  downloadCertificateUrl(enrollmentId) {
    return `${BASE}/enrollments/${enrollmentId}/certificate/download`;
  },
  async validateCertificate(enrollmentId, comment) {
    const { data } = await axios.post(
      `${BASE}/enrollments/${enrollmentId}/validate`,
      { comment: comment || '' },
      { headers: authHeader() },
    );
    return data;
  },
  async rejectCertificate(enrollmentId, reason) {
    const { data } = await axios.post(
      `${BASE}/enrollments/${enrollmentId}/reject`,
      { reason },
      { headers: authHeader() },
    );
    return data;
  },
  async requestNewCertificate(enrollmentId, reason) {
    const { data } = await axios.post(
      `${BASE}/enrollments/${enrollmentId}/request-new`,
      { reason },
      { headers: authHeader() },
    );
    return data;
  },
  async myProgress() {
    const { data } = await axios.get(`${BASE}/my-progress`, { headers: authHeader() });
    return data;
  },
  async pendingValidations() {
    const { data } = await axios.get(`${BASE}/admin/pending-validations`, {
      headers: authHeader(),
    });
    return data;
  },
  async allEnrollments(filters = {}) {
    const { data } = await axios.get(`${BASE}/admin/enrollments`, {
      params: filters,
      headers: authHeader(),
    });
    return data;
  },
  // ============== PHASE 2 · MANAGER ==============
  async managerDashboard(params = {}) {
    const { data } = await axios.get(`${BASE}/manager/dashboard`, {
      params,
      headers: authHeader(),
    });
    return data;
  },
  managerExportCsvUrl(params = {}) {
    const query = new URLSearchParams(params).toString();
    return `${BASE}/manager/export.csv${query ? `?${query}` : ''}`;
  },
  async managerSendReminders(dryRun = false) {
    const { data } = await axios.post(
      `${BASE}/manager/send-reminders?dry_run=${dryRun}`,
      {},
      { headers: authHeader() },
    );
    return data;
  },
  async managerReminderLogs(limit = 100) {
    const { data } = await axios.get(`${BASE}/manager/reminder-logs`, {
      params: { limit },
      headers: authHeader(),
    });
    return data;
  },
  async setUserPoste(userId, poste) {
    const { data } = await axios.put(
      `${BASE}/admin/users/${userId}/poste`,
      { poste },
      { headers: authHeader() },
    );
    return data;
  },
};

export const STATUS_LABELS = {
  en_cours: 'En cours',
  certificat_soumis: 'Certificat soumis',
  validee: 'Validée',
  refusee: 'Refusée',
  expiree: 'Expirée',
};

export const STATUS_TONES = {
  en_cours: 'bg-blue-100 text-blue-700 border-blue-200',
  certificat_soumis: 'bg-amber-100 text-amber-700 border-amber-200',
  validee: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  refusee: 'bg-red-100 text-red-700 border-red-200',
  expiree: 'bg-gray-200 text-gray-700 border-gray-300',
};

export const POSTE_LABELS = {
  auxiliaire: 'Auxiliaire',
  pharmacien: 'Pharmacien',
  administratif: 'Administratif',
};

export const LEVEL_LABELS = {
  debutant: 'Débutant',
  intermediaire: 'Intermédiaire',
  avance: 'Avancé',
  expert: 'Expert',
};
